/**
 * IP制限設定
 * ページ別にIP制限を管理する設定ファイル
 * IPv6基準で管理し、IPv4アドレスはIPv6形式で表現
 */

export interface IPRestrictionConfig {
  pages: {
    [pageName: string]: {
      allowed_ips: string[]
      [elementName: string]:
        | {
            allowed_ips: string[]
          }
        | string[]
        | undefined
    }
  }
}

export const ipRestrictionConfig: IPRestrictionConfig = {
  pages: {
    // 補助金ページ - 特定IPのみアクセス許可
    subsidy: {
      allowed_ips: [
        "::ffff:183.176.244.38", // 伊方町役場
        "::ffff:210.157.239.11", // 伊方町役場
        "::ffff:153.246.255.231", // 河崎宅
        "2400:4051:4e83:4c00::/64", // 河崎宅 ipv6
        "::ffff:159.28.68.212", // SCALA office (guest)
        "::ffff:122.1.17.114", // SCALA proxy
        "2400:2200:696:b504::/64", // 山口モバイル
      ],
    },

    // 取引一覧ページ - 現在制限なし（空配列 = 全IP許可）
    "transaction-list": {
      allowed_ips: [],
      transactionCancelButton: {
        allowed_ips: [
          "::ffff:183.176.244.38", // 伊方町役場
          "::ffff:210.157.239.11", // 伊方町役場
          "::ffff:153.246.255.231", // 河崎宅
          "2400:4051:4e83:4c00::/64", // 河崎宅 ipv6
          "::ffff:159.28.68.212", // SCALA office (guest)
          "::ffff:122.1.17.114", // SCALA proxy
          // "2400:2200:696:b504::1157:6be7"
          "2400:2200:696:b504::/64", // 山口モバイル
        ],
      },
    },

    "resident/edit/*": {
      // 任意の住民に対する編集ページ
      allowed_ips: [],
      "delete-resident-button-container": {
        allowed_ips: [
          "::ffff:183.176.244.38", // 伊方町役場
          "::ffff:210.157.239.11", // 伊方町役場
          "::ffff:153.246.255.231", // 河崎宅
          "2400:4051:4e83:4c00::/64", // 河崎宅 ipv6
          "::ffff:159.28.68.212", // SCALA office (guest)
          "::ffff:122.1.17.114", // SCALA proxy
          "2400:2200:696:b504::/64", // 山口モバイル
        ],
      },
    },
  },
}
